import {
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  useNavigate,
  useParams,
} from 'react-router-dom';
import * as Yup from 'yup';

import {
  Datepicker,
  Form,
  Select,
  Text,
} from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import ShowImageModal from '../../../Components/Modal/ShowImageModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import {
  dateToJalali,
  serverErrorHandler,
} from '../../../Utils/Helpers';
import { SportRuleContext } from '../Context/SportRuleContext';
import {
  getRanks,
  getStatuses,
} from '../Utils/Helpers';

const validationSchema = Yup.object({
  status: Yup.number().typeError(''),
});

const Create = () => {
  const { id } = useParams();
  const context = useContext(SportRuleContext);
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { put, get } = useApi();
  const { error, success } = useToast();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [modalImageShow, setModalImageShow] = useState(false);
  const [imageSrcModal, setImageSrcModal] = useState('');

  useEffect(() => {
    const getData = async () => {
      await getSportRule();
      await getSports();
      await getWeights();
      await getProvinces();
    };
    getData();
  }, [id]);

  const getSports = async () => {
    setLoading(true);
    await get(
      '/sport?all=true',
      (res) => {
        context.sports = res.data;
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات با خطا مواجه شد');
      },
    );
  };
  const getWeights = async () => {
    setLoading(true);
    await get(
      '/weight?all=true',
      (res) => {
        context.weights = res.data;
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات با خطا مواجه شد');
      },
    );
  };

  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        context.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getSportRule = async () => {
    setLoading(true);
    await get(
      `/sport-rule/${id}`,
      (res) => {
        context.sportRule = res.data;
      },
      (err) => {
        setLoading(false);
        error('دریافت اطلاعات با خطا مواجه شد');
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    // values["file_id"] = getPhotoId(values["file"], false);
    await put(
      `/sport-rule/${id}`,
      { status: values['status'] },
      (res) => {
        success(`حکم قهرمانی "${values?.competition_name}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate('/sport-rule');
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`حکم "${values?.competition_name}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ویرایش حکم قهرمانی کشور'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/sport'
      />
      <Form
        initialValues={{
          competition_name: context?.sportRule?.competition_name,
          sport: context?.sportRule?.sport,
          weight: context?.sportRule?.weight,
          file: '',
          number: context?.sportRule?.number,
          date: dateToJalali(context?.sportRule?.date),
          rank: context?.sportRule?.rank,
          status: context?.sportRule?.status,
          province_id: context?.sportRule?.province?.id,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  disabled={true}
                  title='نام مسابقه'
                  name='competition_name'
                  serverError={serverErrors?.competition_name}
                />
              </div>
              <div className='col-12'>
                <Text
                  disabled={true}
                  title='شماره'
                  name='number'
                  serverError={serverErrors?.number}
                />
              </div>
              <div className='col-12'>
                <Datepicker
                  disabled={true}
                  title='تاریخ'
                  name='date'
                  minDate={new Date('1830/01/01')}
                  serverError={serverErrors.date}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Text
                disabled={true}
                title='رشته'
                name='sport'
                serverError={serverErrors?.sport}
              />
            </div>
            <div className='col-12'>
              <Text
                disabled={true}
                title='وزن'
                name='weight'
                serverError={serverErrors?.weight}
              />
            </div>
            <div className='col-12'>
              <Select
                name='rank'
                disabled={true}
                serverError={serverErrors?.rank}
                title='مقام'
                options={getRanks()}
              />
            </div>
            <div className='col-12'>
              <Select
                disabled={true}
                options={context?.provinces}
                title='استان'
                name='province_id'
                serverError={serverErrors?.province_id}
                optionLabel='name'
                optionValue='id'
              />
            </div>
            <div className='col-12'>
              <div className='d-flex flex-row'>
                <img
                  onClick={() => {
                    setImageSrcModal(context.sportRule?.file?.path);
                    setModalImageShow(true);
                  }}
                  className='img-thumbnail c-pointer'
                  src={context.sportRule?.file?.path}
                  style={{ width: '350px', height: '200px' }}
                  alt=''
                />
              </div>
            </div>
            <div className='col-12 mt-2'>
              <Select
                name='status'
                serverError={serverErrors?.status}
                title='وضعیت'
                options={getStatuses()}
              />
            </div>
          </div>
        </div>
      </Form>
      <ShowImageModal
        setModalIsOpen={setModalImageShow}
        modalIsOpen={modalImageShow}
        image={imageSrcModal}
      />
    </Master>
  );
};

export default Create;
